import { Checkbox, type CheckboxProps, FormControlLabel } from '@mui/material';
import { Control, Controller, FieldPathByValue, FieldValues } from 'react-hook-form';

type FormCheckboxProps<T extends FieldValues> = Omit<
  CheckboxProps,
  'checked' | 'name' | 'onBlur' | 'onChange' | 'required' | 'value'
> & {
  name: FieldPathByValue<T, boolean | undefined>;
  control: Control<T>;
  label?: string;
  required?: boolean;
};

export function FormCheckbox<T extends FieldValues>({
  name,
  control,
  label,
  required = false,
  ...props
}: FormCheckboxProps<T>) {
  return (
    <Controller
      name={name}
      control={control}
      rules={{ required }}
      render={({ field }) => (
        <FormControlLabel
          label={label ?? field.name}
          control={
            <Checkbox
              {...props}
              name={field.name}
              checked={field.value === true}
              onChange={(_, checked) => field.onChange(checked)}
              onBlur={field.onBlur}
            />
          }
        />
      )}
    />
  );
}
